import * as React from 'react';
import * as styles from './styles.css';

import { FormFieldInput, IconSearch16 } from '@cian/ui-kit';

export interface ILocationSearchFieldProps {
  value: string;
  placeholder: string;
  isLoading?: boolean;

  onChange(value: string): void;
}

export const LocationSearchField = ({ onChange, value, placeholder, isLoading }: ILocationSearchFieldProps) => {
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value),
    [onChange],
  );

  return (
    <FormFieldInput
      loading={isLoading}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      leftAdornment={
        <div className={styles['loupe']}>
          <IconSearch16 color="black_100" />
        </div>
      }
    />
  );
};

LocationSearchField.displayName = 'LocationSearchField';
